// tslint:disable
export var AlternateCardType;
(function (AlternateCardType) {
    // Unknown
    AlternateCardType[AlternateCardType["Unknown"] = 0] = "Unknown";
    // Previous Client ID
    AlternateCardType[AlternateCardType["PreviousClientId"] = 1] = "PreviousClientId";
    // Mobile #
    AlternateCardType[AlternateCardType["MobileNumber"] = 2] = "MobileNumber";
    // Service Request #
    AlternateCardType[AlternateCardType["ServiceRequestNumber"] = 3] = "ServiceRequestNumber";
    // 3rd Party ID
    AlternateCardType[AlternateCardType["ThirdPartyID"] = 4] = "ThirdPartyID";
})(AlternateCardType || (AlternateCardType = {}));
AlternateCardType['UNKNOWN'] = 0;
AlternateCardType['PREVIOUSCLIENTID'] = 1;
AlternateCardType['MOBILENUMBER'] = 2;
AlternateCardType['SERVICEREQUESTNUMBER'] = 3;
AlternateCardType['THIRDPARTYID'] = 4;
//# sourceMappingURL=AlternateCardType.js.map